module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img15.77ea2a91.jpg";